import React from 'react'
import Typography from '../../typography'
import { PaginationWrapper } from '../style'
import { paginationDisplay } from './helper'

export const coreRender = (
  className: string,
  theme: string,
  activePage: number,
  hrefForPage: any,
  handleButtonClick: any,
  customNextText: string,
  customPreviousText: string,
  text: any,
  showPageNumbers: boolean,
  totalPages: number
) => (
  <PaginationWrapper className={className} data-cy="pagination" $paginationTheme={theme}>
    <div className="Pagination__Inner-Container">
      {activePage !== 1 && (
        <a
          {...(hrefForPage ? { href: hrefForPage(activePage - 1) } : {})}
          className={`Pagination__Previous-Button`}
          onClick={
            hrefForPage
              ? undefined
              : (e: any) => {
                  handleButtonClick(e, activePage - 1)
                }
          }
          rel="prev">
          {getButtonText('Prev', customNextText, customPreviousText, text)}
        </a>
      )}

      {showPageNumbers && generateItems(activePage, totalPages, hrefForPage, handleButtonClick)}

      {activePage !== totalPages && (
        <a
          {...(hrefForPage ? { href: hrefForPage(activePage + 1) } : {})}
          className={`Pagination__Next-Button`}
          onClick={
            hrefForPage
              ? undefined
              : (e: any) => {
                  handleButtonClick(e, activePage + 1)
                }
          }
          rel="next">
          {getButtonText('Next', customNextText, customPreviousText, text)}
        </a>
      )}
    </div>
  </PaginationWrapper>
)

export const generateItems = (
  activePage: number,
  totalPages: number,
  hrefForPage: any,
  handleButtonClick: any
) => {
  const items = paginationDisplay(activePage, totalPages).map(
    (item: number | string, n: number) => {
      const classes =
        item === activePage
          ? 'Pagination__Numbered-Button Pagination__Numbered-Button--Active'
          : 'Pagination__Numbered-Button'

      const href = hrefForPage ? hrefForPage(item) : ''

      if (item === '...') {
        return (
          <Typography className="Pagination__Ellipses" type="bodyXS" key={`Ellipses-${n}`}>
            ...
          </Typography>
        )
      } else {
        return (
          <a
            key={`page-${n}-${href}`}
            href={href}
            className={classes}
            onClick={
              hrefForPage
                ? undefined
                : (e: any) => {
                    handleButtonClick(e, item as number)
                  }
            }>
            {item}
          </a>
        )
      }
    }
  )

  return items
}

export const getButtonText = (
  direction: 'Next' | 'Prev',
  customNextText: string,
  customPreviousText: string,
  text: any
) => {
  let textInner

  if (direction === 'Next') {
    if (customNextText) {
      textInner = customNextText
    } else {
      textInner = (
        <span>
          <span className="Pagination__Mobile-Hide">{text.next}</span>
          {`>`}
        </span>
      )
    }
  } else if (direction === 'Prev') {
    if (customPreviousText) {
      textInner = customPreviousText
    } else {
      textInner = (
        <span>
          {`<`}
          <span className="Pagination__Mobile-Hide">{text.prev}</span>
        </span>
      )
    }
  }

  return (
    <Typography className="Pagination__Button-Text" type="bodyXS">
      {textInner}
    </Typography>
  )
}
